<form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate [attr.aria-busy]="saving">
    <div class="row">
    <div class="col-md-6 mb-3">
        <label class="form-label" [for]="idPrefix + '-title'">
            Title @if (!readOnly) { <span class="text-red" aria-hidden="true">*</span><span class="visually-hidden">(required)</span> }
        </label>
        <input type="text" class="form-control" [id]="idPrefix + '-title'" formControlName="title"
               [class.is-invalid]="showError('title')"
               [attr.aria-required]="!readOnly"
               [attr.aria-invalid]="showError('title')"
               [attr.aria-describedby]="describedBy('title')"
               data-testid="contract-title">
        @if (showError('title')) {
            <div class="field-error" role="alert" [id]="idPrefix + '-title-error'">
                @if (form.controls.title.hasError('required')) { Title is required. }
                @else { Title must be {{ titleMaxLength }} characters or fewer. }
            </div>
        }
    </div>

    <div class="col-md-6 mb-3">
        <label class="form-label" [for]="idPrefix + '-code'">
            Code @if (!readOnly && !codeReadOnly) { <span class="text-red" aria-hidden="true">*</span><span class="visually-hidden">(required)</span> }
        </label>
        <input type="text" class="form-control" [id]="idPrefix + '-code'" formControlName="code"
               [class.is-invalid]="showError('code')"
               [attr.aria-required]="!readOnly && !codeReadOnly"
               [attr.aria-invalid]="showError('code')"
               [attr.aria-describedby]="describedBy('code')"
               data-testid="contract-code">
        @if (showError('code')) {
            <div class="field-error" role="alert" [id]="idPrefix + '-code-error'" data-testid="contract-code-error">
                @if (serverCodeError) { {{ serverCodeError }} }
                @else if (form.controls.code.hasError('required')) { Code is required. }
                @else { Code must be {{ codeMaxLength }} characters or fewer. }
            </div>
        }
    </div>

    <div class="col-md-6 mb-3">
        <label class="form-label" [for]="idPrefix + '-serviceProvider'">Service provider</label>
        <input type="text" class="form-control" [id]="idPrefix + '-serviceProvider'" formControlName="serviceProvider"
               [class.is-invalid]="showError('serviceProvider')"
               [attr.aria-invalid]="showError('serviceProvider')"
               [attr.aria-describedby]="describedBy('serviceProvider')"
               data-testid="contract-service-provider">
        @if (showError('serviceProvider')) {
            <div class="field-error" role="alert" [id]="idPrefix + '-serviceProvider-error'">
                Service provider must be {{ serviceProviderMaxLength }} characters or fewer.
            </div>
        }
    </div>

    <div class="col-md-6 mb-3">
            <label class="form-label" [for]="idPrefix + '-signatureDate'">Signature date</label>
            <input type="date" class="form-control" [id]="idPrefix + '-signatureDate'" formControlName="signatureDate"
                   [class.is-invalid]="showError('signatureDate')"
                   [attr.aria-invalid]="showError('signatureDate')"
                   [attr.aria-describedby]="describedBy('signatureDate')"
                   data-testid="contract-signature-date">
            @if (showError('signatureDate')) {
                <div class="field-error" role="alert" [id]="idPrefix + '-signatureDate-error'">Enter a valid signature date.</div>
            }
    </div>
    <div class="col-md-6 mb-3">
            <label class="form-label" [for]="idPrefix + '-kickoffDate'">Kickoff date</label>
            <input type="date" class="form-control" [id]="idPrefix + '-kickoffDate'" formControlName="kickoffDate"
                   [class.is-invalid]="showError('kickoffDate')"
                   [attr.aria-invalid]="showError('kickoffDate')"
                   [attr.aria-describedby]="describedBy('kickoffDate')"
                   data-testid="contract-kickoff-date">
            @if (showError('kickoffDate')) {
                <div class="field-error" role="alert" [id]="idPrefix + '-kickoffDate-error'">Enter a valid kickoff date.</div>
            }
    </div>
    </div>

    <div class="contract-form-actions">
        <div class="contract-form-actions-extra">
            <ng-content></ng-content>
        </div>
        @if (!readOnly) {
            <button type="submit" class="btn btn-success" [disabled]="!canSave" [attr.aria-busy]="saving"
                    data-testid="contract-save-btn">
                <i class="bi bi-floppy me-2" aria-hidden="true"></i>Save
            </button>
            <span class="visually-hidden" role="status" aria-live="polite">{{ saving ? 'Saving contract' : '' }}</span>
        }
    </div>
</form>
